// gerado por work/gerar_pdp.py - nao editar a mao
(function () {
  function ligar() {
    var alvo = document.getElementById('ionix-sg-overlay') || document.querySelector('.ix-pp');
    if (!alvo) return;
    var raiz = alvo.closest('.product-info') || document.body;
    if (raiz.dataset.ewcLigado === '1') return;
    raiz.dataset.ewcLigado = '1';
    /* guia */
    (function() {
      var overlay = document.getElementById('ionix-sg-overlay');
      var openBtn = document.getElementById('ionix-sg-open');
      var closeBtn = document.getElementById('ionix-sg-close');
      if (!overlay || !openBtn || !closeBtn) return;

      function openModal() { overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
      function closeModal() { overlay.classList.remove('is-open'); document.body.style.overflow = ''; }
      openBtn.addEventListener('click', openModal);
      closeBtn.addEventListener('click', closeModal);
      overlay.addEventListener('click', function(e) { if (e.target === overlay) closeModal(); });
      document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal(); });

      var tabs = overlay.querySelectorAll('.ionix-sg-tab');
      var panels = overlay.querySelectorAll('.ionix-sg-panel');
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var target = tab.getAttribute('data-tab');
          tabs.forEach(function(t) { t.classList.toggle('is-active', t === tab); t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          panels.forEach(function(p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === target); });
        });
      });

      // TEE body targets — max body CHEST measurement per size (range upper bound), with 20% stretch
      var SIZES = [
        { label: 'S',   chestIn: 32,   lengthCm: 52, us: '0–4',   uk: '4–8',   eu: '32–36' },
        { label: 'M',   chestIn: 34.5, lengthCm: 54, us: '6–8',   uk: '10–12', eu: '38–40' },
        { label: 'L',   chestIn: 37,   lengthCm: 56, us: '10–12', uk: '14–16', eu: '42–44' },
        { label: 'XL',  chestIn: 39.5, lengthCm: 58, us: '14',    uk: '18',    eu: '46'    },
        { label: '2XL', chestIn: 41.7, lengthCm: 60, us: '16–18', uk: '20–22', eu: '48–50' },
        { label: '3XL', chestIn: 44,   lengthCm: 62, us: '20',    uk: '24',    eu: '52'    }
      ];

      var state = { unit: 'cm', chest: null, height: null, fit: 'balanced' };

      var inputChest  = document.getElementById('ionix-ff-chest');
      var inputHeight = document.getElementById('ionix-ff-height');
      var chestUnit   = document.getElementById('ionix-ff-chest-unit');
      var heightUnit  = document.getElementById('ionix-ff-height-unit');
      var errorBox    = document.getElementById('ionix-ff-error');
      var progressBar = document.getElementById('ionix-ff-bar');
      var stepLabel   = document.getElementById('ionix-ff-step-label');
      var unitButtons = overlay.querySelectorAll('.ionix-ff-unit');
      var steps       = overlay.querySelectorAll('.ionix-ff-step');

      function setUnit(unit) {
        state.unit = unit;
        unitButtons.forEach(function(b) { b.classList.toggle('is-active', b.getAttribute('data-unit') === unit); });
        var label = unit === 'cm' ? 'cm' : 'in';
        chestUnit.textContent = label; heightUnit.textContent = label;
        inputChest.placeholder  = unit === 'cm' ? "e.g." + ' 90'  : "e.g." + ' 35';
        inputHeight.placeholder = unit === 'cm' ? "e.g." + ' 165' : "e.g." + ' 65';
      }

      unitButtons.forEach(function(b) { b.addEventListener('click', function() { setUnit(b.getAttribute('data-unit')); }); });

      function setStep(n) {
        steps.forEach(function(s) { s.classList.toggle('is-active', parseInt(s.getAttribute('data-step'), 10) === n); });
        progressBar.style.width = (n * 33.33) + '%';
        stepLabel.textContent = "Step __N__ of 3".replace('__N__', n);
      }

      function readMeasurements() {
        var c = parseFloat(inputChest.value);
        var ht = parseFloat(inputHeight.value);
        if (isNaN(c) || c <= 0) return { ok: false, msg: "Please enter your chest measurement." };
        var cIn = state.unit === 'in' ? c : c / 2.54;
        if (cIn < 24 || cIn > 60) return { ok: false, msg: "Your chest measurement seems off — please double-check." };
        state.chest = cIn;
        state.height = isNaN(ht) ? null : ht;
        return { ok: true };
      }

      function recommend() {
        var chestIdx = -1;
        for (var i = 0; i < SIZES.length; i++) {
          if (chestIdx === -1 && state.chest <= SIZES[i].chestIn) { chestIdx = i; break; }
        }
        var outOfRange = false;
        if (chestIdx === -1) { chestIdx = SIZES.length - 1; outOfRange = true; }

        var baseIdx = chestIdx;
        var finalIdx = baseIdx;
        if (state.fit === 'firm' && baseIdx > 0) {
          var s = SIZES[baseIdx];
          if ((s.chestIn - state.chest) > 1.2) finalIdx = baseIdx - 1;
        }

        var heightWarning = null;
        if (state.height) {
          var heightCm = state.unit === 'cm' ? state.height : state.height * 2.54;
          if (heightCm < 155) heightWarning = "You're shorter than average — the tee may feel long. Consider sizing down if between sizes.";
          else if (heightCm > 180) heightWarning = "You're taller than average — the tee may sit a bit short at the hips.";
        }

        return { size: SIZES[finalIdx], baseSize: SIZES[baseIdx], didAdjust: finalIdx !== baseIdx, outOfRange: outOfRange, heightWarning: heightWarning };
      }

      function renderResult() {
        var r = recommend();
        var s = r.size;
        var lengthIn = (s.lengthCm / 2.54).toFixed(1);

        var html = '';
        html += '<p class="ionix-ff-result__title">' + "Your Recommended Size" + '</p>';
        html += '<p class="ionix-ff-result__size">' + s.label + '</p>';
        html += '<p class="ionix-ff-result__intl">US ' + s.us + ' &middot; UK ' + s.uk + ' &middot; EU ' + s.eu + '</p>';

        html += '<div class="ionix-ff-result__rows">';
        html += '  <div class="ionix-ff-result__row"><span class="ionix-ff-result__row-label">' + "Chest fits up to" + '</span><span class="ionix-ff-result__row-value">' + s.chestIn + '" (' + Math.round(s.chestIn * 2.54) + ' cm)</span></div>';
        html += '  <div class="ionix-ff-result__row"><span class="ionix-ff-result__row-label">' + "Tee length" + '</span><span class="ionix-ff-result__row-value">' + lengthIn + '" (' + s.lengthCm + ' cm)</span></div>';
        html += '</div>';

        if (r.outOfRange) {
          html += '<div class="ionix-ff-result__note ionix-ff-result__note--warn"><strong>' + "You may be outside our size range." + '</strong>' + "Our largest size (3XL) fits up to 44\" chest. Please contact our team before ordering." + '</div>';
        } else if (r.didAdjust) {
          html += '<div class="ionix-ff-result__note"><strong>' + "Shaping preference applied." + '</strong>' + "One size down (__A__ instead of __B__) for a stronger slimming effect.".replace('__A__', r.size.label).replace('__B__', r.baseSize.label) + '</div>';
        } else {
          html += '<div class="ionix-ff-result__note"><strong>' + "Perfect match." + '</strong>' + "__A__ fits your chest comfortably with visible shaping effect.".replace('__A__', s.label) + '</div>';
        }

        if (r.heightWarning) html += '<div class="ionix-ff-result__note ionix-ff-result__note--warn"><strong>' + "Length note." + '</strong>' + r.heightWarning + '</div>';

        document.getElementById('ionix-ff-result').innerHTML = html;
      }

      document.getElementById('ionix-ff-to-step2').addEventListener('click', function() {
        var m = readMeasurements();
        if (!m.ok) { errorBox.textContent = m.msg; return; }
        errorBox.textContent = ''; setStep(2);
      });

      document.getElementById('ionix-ff-to-result').addEventListener('click', function() {
        var checked = overlay.querySelector('input[name="ff-fit"]:checked');
        state.fit = checked ? checked.value : 'balanced';
        renderResult(); setStep(3);
      });

      overlay.querySelectorAll('.ionix-ff-back').forEach(function(b) {
        b.addEventListener('click', function() { setStep(parseInt(b.getAttribute('data-go'), 10)); });
      });

      document.getElementById('ionix-ff-restart').addEventListener('click', function() {
        inputChest.value = ''; inputHeight.value = '';
        errorBox.textContent = ''; state.chest = state.height = null; state.fit = 'balanced';
        var defaultFit = overlay.querySelector('input[name="ff-fit"][value="balanced"]');
        if (defaultFit) defaultFit.checked = true;
        setStep(1);
      });

      setStep(1);
    })();

    /* confianca */
    (function(){var f=document.getElementById('ix-flag'),c=document.getElementById('ix-country'),s=document.getElementById('ix-sold');/* country + flag rendered server-side from Shopify Markets (localization.country) */var n=Math.floor(Math.random()*6)+12;if(s)s.textContent="__N__ sold in the last hour".replace('__N__', n);(function loop(){setTimeout(function(){var r=Math.random();if(r<.35)n+=1;else if(r<.5)n+=2;if(n>28)n=11+Math.floor(Math.random()*4);if(s){s.style.opacity='0';setTimeout(function(){s.textContent="__N__ sold in the last hour".replace('__N__', n);s.style.opacity='1'},200)}loop()},10000+Math.floor(Math.random()*15000))})()});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ligar);
  } else {
    ligar();
  }
  var pendente = null;
  new MutationObserver(function () {
    clearTimeout(pendente);
    pendente = setTimeout(ligar, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
